import React, { useCallback, useState } from 'react';
import cn from 'classnames';
import { useGoogleLogin, GoogleLoginResponse, GoogleLoginResponseOffline } from 'react-google-login';

import Icons from '../../shared/Icons';
import { UserService } from '../../services';

import classes from './SignUpModal.module.scss';
import popupStyles from '../Popup.module.scss';

export default function SignUpModal(props: { handleClose: () => void }) {
  const { handleClose = () => {} } = props;
  const [hasAnAccount, setHasAnAccount] = useState(false);
  const logInButtonText = useCallback(() => {
    return hasAnAccount ? 'Sign in' : 'Sign up';
  }, [hasAnAccount]);
  const logInByType = useCallback((vendor: 'google' | 'facebook') => {
    // TODO: add logic with correct evaluation of user's action
  }, []);
  const googleLoginSuccess = useCallback((res: any) => {}, []);
  const googleLoginFailure = useCallback((res: any) => {
    console.error('Login with Google has failed: re: ', res);
  }, []);
  const { signIn: googleSignIn } = useGoogleLogin({
    onSuccess: googleLoginSuccess,
    onFailure: googleLoginFailure,
    clientId: UserService.GOOGLE_CLIENT_ID,
    cookiePolicy: 'single_host_origin'
  });

  return (
    <div className={popupStyles.popupBox}>
      <div className={cn(popupStyles.wrapper, classes.SignUpModal)}>
        <button className={popupStyles.close} onClick={() => handleClose()}>
          <Icons iconType="close" iconClass={popupStyles.closeIcon} />
        </button>

        <div className={classes.halfWidth}>
          <h2 className={classes.title}>
            Ask Questions. Get Answers
            <div className={classes.subtitle}>
              Vote on topics that matter to you and your community
              <br />
              and be a part of the change you want to see.
            </div>
          </h2>
          <div className={classes.authOptions}>
            <button className={classes.facebook} onClick={() => logInByType('facebook')}>
              <div className={cn(classes.icon, classes.facebook)}></div>
              <span>{logInButtonText()} with Facebook</span>
            </button>

            <button className={classes.google} onClick={googleSignIn}>
              <div className={cn(classes.icon, classes.google)}></div>
              <span>{logInButtonText()} with Google</span>
            </button>
            {/* <GoogleLogin
              clientId={UserService.GOOGLE_CLIENT_ID}
              render={renderProps => (
                null
              )}
              buttonText="Login"
              onSuccess={googleLoginSuccess}
              onFailure={() => console.log('failure')}
              cookiePolicy={'single_host_origin'}
            /> */}
            <button className={classes.email} data-function="showEmailOptions( 'sign-up' )">
              <div className={cn(classes.icon, classes.email)}></div>
              <span>{logInButtonText()} with Email</span>
            </button>
          </div>
          <div className={classes.switchAuthPopup}>
            {hasAnAccount ? 'Not a Member Yet?' : 'Already a Member?'} &nbsp;
            <span className={classes.linkTextGreen} onClick={() => setHasAnAccount(val => !val)}>
              {hasAnAccount ? 'Sign Up' : 'Sign In'}
            </span>
          </div>
          <div className={classes.emailOptions}>{/* SignUpForm */}</div>
        </div>
        <div className="after-form-completion full-width hidden">
          <div className="title text-center">
            <div className="icon"></div>
            <span>Awesome. Thank you! Well, we just sent you a confirmation email to make sure it's really you.</span>
          </div>
          <div className="button-group">
            <button type="button" onClick={() => handleClose()}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
